import dayjs from "dayjs";
import { array, date, object, string } from "yup";

export const DEFAULT_DIAL_CODE = 62;

export const DEFAULT_VALUES = {
  name: "",
  gender: "",
  dateOfBirth: null,
  email: "",
  phoneNumbers: [{ dialCode: DEFAULT_DIAL_CODE, number: "" }],
  accountingActionChartOfAccounts: {},
};

// Define date boundaries
const threeYearsAgo = dayjs().subtract(3, "years").toDate();
const oneHundredTwentyYearsAgo = dayjs().subtract(120, "years").toDate();

// Walk-in buyers use the one existing "UMUM" customer, so names containing the
// word "umum" or "pelanggan" are rejected (same rule as the backend).
const GENERIC_CUSTOMER_NAME = /\b(umum|pelanggan)\b/i;

export const VALIDATION_SCHEMA = object().shape({
  name: string()
    .required("Harus diisi")
    .matches(/^[A-Za-z\s]+$/, "Hanya huruf dan spasi yang diperbolehkan")
    .test(
      "not-generic-customer",
      "Gunakan pelanggan UMUM yang sudah ada",
      (value) => !GENERIC_CUSTOMER_NAME.test(value ?? "")
    ),
  email: string()
    .nullable()
    .transform((value) => (value === "" ? null : value))
    .email("Email tidak valid"),
  gender: string().required("Harus diisi"),
  dateOfBirth: date()
    .nullable()
    .required("Harus diisi")
    .typeError("Format tanggal tidak valid")
    .max(threeYearsAgo, "Tanggal lahir harus minimal 3 tahun yang lalu")
    .min(
      oneHundredTwentyYearsAgo,
      "Tanggal lahir tidak boleh lebih dari 120 tahun yang lalu"
    ),
  phoneNumbers: array().of(
    object().shape({
      dialCode: string().required("Harus diisi"),
      number: string()
        .required("Harus diisi")
        .min(8, "Minimal 8")
        .max(13, "Maksimal 13"),
    })
  ),
});
